import {useSettings} from '@wix/tpa-settings/react'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import React from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import {settingsParams} from '../../../../../settingsParams'
import {TitleProps} from './interfaces'
import {classes} from './title.st.css'

export const Title: React.FC<TitleProps> = ({title, className}) => {
  const settings = useSettings()
  const titleTag = settings.get(settingsParams.titleTag) as string

  return (
    <Text className={classNames(className, classes.title)} data-hook={DH.headerEventTitle} tagName={titleTag}>
      {title}
    </Text>
  )
}
